import { type ShellElement } from '../../common/shell-element'

export const GOTO_TEXT_HIGHLIGHT = 'goto-text-highlight'

export interface ITextHighlightComponent {}

export type GotoTextHighlightComponent = ShellElement & ITextHighlightComponent
